import React from 'react';

const About = () => {
  return (
    <div className="container my-5 py-4">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="card shadow-lg border-0 rounded-4 p-4">
            <div className="card-body">
              <h1 className="card-title text-center mb-4 fw-bold display-5">About Us</h1>
              <p className="card-text fs-5">
                Welcome to <strong>City Choice General Trading LLC</strong>, Dubai's premier destination for retail and wholesale mobile solutions since 2005. With a focus on exceptional customer experiences and cutting-edge technology, we offer a diverse range of telecom products, including mobile phones, laptops, perfumes, watches, and more.
              </p>
              <p className="card-text fs-5">
                Our knowledgeable sales staff ensures personalized service, while our commitment to affordability and authenticity has made us a trusted name in Bur Dubai.
              </p>
              <p className="card-text fs-5">
                <strong>Exciting news!</strong> We've expanded our reach with the launch of <strong>EESOUQ</strong>, our online platform offering a wide selection of products, such as mobile phones, laptops, perfumes, watches, and more. Experience the convenience of shopping from anywhere while enjoying the same quality and dedication that defines City Choice General Trading LLC.
              </p>
              <p className="card-text fs-5">
                Explore our offerings today and discover why City Choice is the preferred destination for all your mobile and electronic needs. <strong>Thank you for choosing City Choice</strong>, where customer satisfaction is our top priority.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
